export default "__VITE_ASSET__Bmva7_8S__"